import route from '@/admin/locale/ru_RU/route';
import base from "@/admin/locale/ru_RU/base";
import menu from "@/admin/locale/ru_RU/menu";

export default {
  route,
  menu,
  ...base,
};
